import { render, staticRenderFns } from "./AddNewButtonPage.vue?vue&type=template&id=d01ca852&scoped=true"
import script from "./AddNewButtonPage.vue?vue&type=script&lang=js"
export * from "./AddNewButtonPage.vue?vue&type=script&lang=js"
import style0 from "./AddNewButtonPage.vue?vue&type=style&index=0&id=d01ca852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01ca852",
  null
  
)

export default component.exports